import Vue from 'vue'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required,
  email,
  confirmed,
  max,
  size,
  min
} from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en'

// import only needed rules for validation
const rules = {
  required,
  email,
  confirmed,
  max,
  min,
  size
}

// loop over all rules
for (var rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: en.messages[rule] // add its message
  })
}

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
